
import React from "react";
import { Box, Typography, ThemeProvider, Button } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { motion } from "framer-motion";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import blogs from '../../../../assets/json/blog-data.json'
import { useParams } from "react-router-dom";
const HeroSection = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1,
  },
}));

const HeroContent = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 2,
  color: "white",
  padding: theme.spacing(4),
  textAlign: "left",
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
  },
}));

const HeroTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontFamily: "Helvetica Neue",
  marginBottom: theme.spacing(0.5),
  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
  [theme.breakpoints.down("md")]: {
    fontSize: "2.5rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));



export default function FluidHeroSection() {

  const theme = useTheme();
  const { id } = useParams<{ id: string }>();

  if (!id) return <p>Invalid blog ID</p>;

  const blog = blogs.find((b) => b.id === parseInt(id));
  if (!blog) return <p>Blog not found</p>;

  // Split the title into two lines based on word count
  const words = blog.title.split(" ");
  const halfIndex = Math.ceil(words.length / 2); // Split roughly in half
  const lines = [
    words.slice(0, halfIndex).join(" "), // First half
    words.slice(halfIndex).join(" "),    // Second half
  ];
  return (
    <ThemeProvider theme={theme}>
      <HeroSection
      >
        <Box
          component="img"
          src={blog.imagePath}
          alt="Award Background"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",

            zIndex: -1,
          }}
        />

        <HeroContent sx={{ position: "absolute", left: "5%", top: "60%", transform: "translateY(-50%)" }}>
          {lines.map((line, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: index * 0.5 }}
            >
              <HeroTitle variant="h3">{line}</HeroTitle>
            </motion.div>
          ))}


        </HeroContent>
      </HeroSection>
    </ThemeProvider>
  );
}